import * as Tabs from "../modules/tabs";

namespace KWS.controllers.tabs {

    export function init() {
        Tabs.init();
    }
}

KWS.controllers.tabs.init();